export const PAGE_LIMIT_OPTIONS = [10, 20, 50];
export const DEFAULT_PAGE_LIMIT = 20;
